<template>
    <div>
        <div class="p-grid">
            <div class="p-col-12">
                <div class="card">
                    <DataTable
                        ref="dt"
                        :value="datatable.data"
                        :loading="datatable.loading"
                        rowGroupMode="rowspan"
                        :groupRowsBy="['name','id']"
                        @rowReorder="onRowReorder"
                        style="font-size: 12px; overflow-x: auto"
                    >
                        <template #header>
                            <div class="flex" style="gap: 20px; align-items:center;">
                           Перегрузить базу данных ЩО-125 из Excel
                            <input type="file"
                                @change="onChange"
                                ref="file"
                            >
                                <b style="color:red; text-decoration:underline;" v-if="historyData">{{ historyData.file_name }} ({{ moment(historyData.created_at).format("DD.MM.YYYY HH:mm") }})</b>
                                <b v-if="historyData">{{ historyData.user.email }}</b>
                                <textarea style="width:400px;" v-if="historyData" v-model="historyData.comment" v-on:keyup.enter="updateHistoryComment(historyData.id, historyData.comment, 'sho125')" placeholder="Комментарий"></textarea>
                            </div>
                            <br>
                            <ProgressBar mode="indeterminate" style="height: .5em" v-if="progress" />
                        </template>
                        <Column field="id" :rowReorder="true" :reorderableColumn="false" header="">
                            <template #body="slotProps">
                                <div class="table-actions">
                                    <a :href="route('api.sho125_service.edit', {service: slotProps.data.id})">
                                        <i :class="['p-datatable-reorderablerow-handle', 'pi pi-eye']" v-if="!slotProps.data.virtual"></i>
                                    </a>
                                </div>
                            </template>
                        </Column>
                        <Column field="id" header="#">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.id ? slotProps.data.id : null
                                }}
                            </template>
                        </Column>
                        <Column field="file" header="Опис системи">
                            <template #body="slotProps">
                                <a :href="slotProps.data.file" v-if="slotProps.data.file">{{ slotProps.data.file }}</a>
                                <span v-else>-</span>
                            </template>
                        </Column>
                        <Column field="name" header="Назва">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.name ? slotProps.data.name : null
                                }}
                            </template>
                        </Column>
                    </DataTable>
                    <pagination v-model="filter.page" :records="total" :per-page="20" @paginate="loadLazyData()"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Menubar from "primevue/menubar";
import Column from "primevue/column";
import Row from "primevue/row";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import AutoComplete from "primevue/autocomplete";
import CalculatorService from "../Services/CalculatorService";
import axios from "axios";
import DeleteConfirmation from '../mixins/components/delete.vue';
import Pagination from 'v-pagination-3';
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import FormHelper from './mixins/form_helper';
import ProgressBar from 'primevue/progressbar';

export default {
    name: "Index",
    layout: AppLayout,
    props: {
        history: {
            type: Object,
            required: false,
        }
    },
    components: {
        ProgressBar,
        AppLayout,
        Menubar,
        DataTable,
        Column,
        Row,
        ColumnGroup,
        Button,
        InputText,
        InputNumber,
        AutoComplete,
        DeleteConfirmation,
        Pagination,
    },
    mixins: [FormHelper],
    data() {
        return {
            moment: moment,
            progress: false,
            total: 0,
            historyData: this.history,
            filter: {
                page: 1,
                search: null,
                status: null,
                type: null,
                by: 'id',
                dir: 'asc',
            },
            filteredCompetitorArticles: null,
            selectedCompetitorArticle: [],
            tableDiscount: {},
            tableCount: {},
            defaultPercent: 0,
            defaultCount: 1,
            buyer: null,
            datatable: {
                loading: false,
                data: [],
                lazyParams: {}
            },
            virtualTableData: [],
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
            selectedTableRow: null,
            emptyRowIndex: 0,
            focused: {},
            buyerReadonly: false,
            competitorIds: [],
            competitorArticleNameEdit: {},
        }
    },
    calculatorService: null,
    created() {
        this.calculatorService = new CalculatorService();
    },
    mounted() {
        this.loadLazyData();
    },
    methods: {
        deleteVirtualTableDataRow(competitorArticleName) {
            let virtualTableIndex = this.findVirtualTableRowIndex(competitorArticleName);

            this.virtualTableData.splice(virtualTableIndex, 1);
        },
        loadLazyData() {
            if (this.filter.search) {
                this.filter.page = 1;
            }
            
            this.datatable.lazyParams = {
                search: this.competitorIds,
            };
            this.datatable.loading = true;
            this.datatable.lazyParams['buyer'] = this.buyer;
            this.calculatorService.getData(this.route('api.sho125.list', this.filter), this.datatable.lazyParams).then(data => {
                this.total = data.total;
                this.datatable.data = data.data.concat(this.virtualTableData);

                this.defineDefaultData();

                this.datatable.loading = false;

                window.scroll(0, 0);
            });
        },
        defineDefaultData() {
            this.datatable.data.forEach(function (data, index) {
                if (!data.id) {
                    return;
                }
                if (typeof this.tableDiscount[data.id] === "undefined") {
                    this.tableDiscount[data.id] = this.defaultPercent;
                }
                if (typeof this.tableCount[data.id] === "undefined") {
                    this.tableCount[data.id] = this.defaultCount;
                }
            }, this);
        },
        onRowReorder(event) {
            if (event.dragIndex === event.dropIndex) {
                return;
            }

            let moveId = this.datatable.data[event.dragIndex]['id'];
            let beforeId = this.datatable.data[event.dropIndex]['id'];

            let indexId = this.competitorIds.indexOf(moveId);
            let indexBeforeId = this.competitorIds.indexOf(beforeId);
            this.moveArrayItem(this.competitorIds, indexId, indexBeforeId);
            this.loadLazyData();
        },
        moveArrayItem(arr, fromIndex, toIndex) {
            let element = arr[fromIndex];
            arr.splice(fromIndex, 1);
            arr.splice(toIndex, 0, element);
        },

        onChange() {
            let file = this.$refs.file.files[0];

            this.progress = true;

            this.sendData = new FormData();
            this.collectFormData({file: file});

            axios.post(this.route('api.sho125.upload'),
                this.sendData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                })
                .then((result) => {
                    window.scroll(0, 0);
                    this.progress = false;
                    this.$toast.add({severity: 'info', summary: 'Success', detail: 'Data updated', life: 3000});
                    // location.reload();
                    this.historyData = result.data.history;
                }).catch((error) => {
                    this.$toast.add({severity: 'info', summary: 'Error', detail: 'Error', life: 3000});
                    this.progress = false;
                    
                    console.log(error);
                    window.scroll(0, 0);
                })

        },

        updateHistoryComment(id, text, type) {
            axios.post(this.route('api.update_history'), {id: id, comment: text, type: type})
            .then((result) => {
                this.$toast.add({severity: 'info', summary: 'Success', detail: 'Comment updated', life: 3000});
            }).catch((error) => {
                console.log(error);
            })
        }
    }
}
</script>

<style scoped>
.p-button-danger {
    color: red;
}
.VuePagination .VuePagination__pagination-item {
    list-style: none!important;
}
.font-12 {
    font-size: 12px;
}
</style>